import { ssrApi } from 'api/ssr';
import { IProvider } from 'constants/types';
import { AllPovidersPage } from 'components/template/providers';

export default function AllProviders({
  providers,
}: {
  providers: IProvider[];
}) {
  return <AllPovidersPage providers={providers} />;
}

export async function getServerSideProps() {
  const results = await ssrApi.providers.list();

  return {
    props: { providers: results?.results ?? [] },
  };
}
